import { Component, OnInit, ViewChild, ChangeDetectorRef, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { ProfileService } from './services/profile.service';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { ProfileDto, ProfileModel } from './model/profile.model';
import { PucaComponent } from '../../puca.component';
// import { Ng2ImgMaxService } from 'ng2-img-max';
import { NgxImageCompressService } from 'ngx-image-compress';
import { decrypt, encrypt } from '../../../../../utilities/utilityFunctions';
import { Router } from '@angular/router';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';
import { GoogleAnalyticsService } from '../../../../../shared/sharedServices/google-analytics.service';
import { PucaService } from '../../services/puca.service';
import { EligibilityModel } from '../../model/eligibility-model';
import { PucaDataService } from '../../services/puca-data.service';
import moment from 'moment';
@Component({
	selector: 'kt-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
  @Input('formType') formType: string;
  @ViewChild('personalDetailsForm', { static: false }) personalDetailsForm: NgForm;
  @Input('dropdownList') dropdownList: any;
  @Input()isAdmin: boolean;
  public addressDetailsData: any = [
    { addressType: 'Permanent', addressTypeCode: 10201 },
    { addressType: 'Mailing', addressTypeCode: 10202 },
  ];
  public loader: boolean = false;
  public personalDetailsData: ProfileDto = new ProfileDto();;
  public nationalityData: any;
  public profileAvatarImg: string = HEC_CONSTANTS.CONSTANT_VALUES.DEFAULT_IMG_PATH;
  public selectedCountryId: any = [];
  public cityList: any = [];
  public districtList: any = [];
  public profileDetails: ProfileModel = new ProfileModel();
  public postalList: any = [];
  public alertMsgValue: string;
  public isAlertVisible: boolean = false;
  public alertClass: string;
  public alertIcon: string;
  private selectedFilePayload: any;
  private attachmentBase64: string;
  public isImageAlert: boolean = false;
  public alertType: string;
  private fileExt: string = HEC_CONSTANTS.CONSTANT_VALUES.imageFileExt;
  private maxSize: number = HEC_CONSTANTS.CONSTANT_VALUES.maxSize;
  private isImgAvailable: boolean = false;
  public matchedAddress: boolean = false;
  public isLocked: boolean = false;
  public primaryNationality: any;
  @Output() nextComponent= new EventEmitter();
  public dropdownValues: any = { genderValue: '', maritalValue: '', countryValue: '', religionValue: '', identityValue: '' };
  constructor(private sharedService: SharedService, private cdr: ChangeDetectorRef, 
    // private ng2ImgMax: Ng2ImgMaxService,
    private imageCompress: NgxImageCompressService,
    private profileService: ProfileService, private router: Router,
    private loaderService: LoaderService,private gaService:GoogleAnalyticsService, private pucaService: PucaService, private pucaDataService: PucaDataService
  ) { }
  async ngOnInit() {
    window.scroll(0,0);
	this.gaService.setPage('/form','ESP Page');
	if(this.pucaDataService.isAdmin) await this.getUserPersonalDetailsAdmin(this.pucaDataService.application.commonProfileId);
	else await this.getUserPersonalDetails();
  }
  ngOnDestroy() {
    // this.dasDataService.formView = undefined;
    // this.dasDataService.applicationId = undefined;
  }
  public goNext() {
	this.checkEligibility()
  }
  public getUserPicture(type?) {
    this.sharedService.getUserProfilePicture().subscribe(
      (res: HecResponse) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          if (res.data != "") {
           this.profileAvatarImg = res.data;
          // this.profileAvatarImg = this.cleanBase64Image(res.data);
          console.log("profile Image: ", this.profileAvatarImg);
            this.isImgAvailable = true;
            this.isImageAlert = false;
            if (type == 'local') {
              this.loader = false;
              this.loaderService.setValue(this.loader);
            }
            localStorage.removeItem('Avatar')
            localStorage.setItem('Avatar', encrypt(res.data))
            this.cdr.detectChanges();
          } else {
            this.profileAvatarImg = '/assets/media/users/default.jpg';
            this.cdr.detectChanges();
          }
        }
      }
    )
  }

  // cleanBase64Image(data: string): string {
  //   // Extract valid prefix
  //   const prefixMatch = data.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,/i);
  //   if (!prefixMatch) {
  //     throw new Error('Invalid base64 image format.');
  //   }
  
  //   const mimeType = prefixMatch[1]; // e.g., image/png
  
  //   // Remove prefix entirely
  //   let rest = data.replace(/^data:(image\/[a-zA-Z0-9.+-]+);base64,/i, '');
  
  //   // Remove any invalid repeated junk like "dataimage/pngbase64" anywhere in the string
  //   rest = rest.replace(/dataimage\/[a-zA-Z0-9.+-]+base64/gi, '');
  
  //   // Optional: remove non-base64 characters
  //   const base64Clean = rest.replace(/[^A-Za-z0-9+/=]/g, '').trim();
  
  //   // Return valid base64 image
  //   return `data:${mimeType};base64,${base64Clean}`;
  // }
  
  public getUserPersonalDetails() {
    return new Promise((resolve, reject) => {
      this.sharedService.getPersonalDetails().subscribe(
        async (res: HecResponse) => {
          for (let i = 0; i < this.dropdownList.maritalStatusList.length; i++) {
            this.dropdownList.maritalStatusList[i].id = 'a' + this.dropdownList.maritalStatusList[i].value
          }
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.personalDetailsData = res.data.personalDetail;
            this.nationalityData = res.data.nationalityDtos;
            this.isLocked = res.data.islocked
            localStorage.setItem('loginDetails',encrypt(JSON.stringify(res.data.loginDetail)))
            if (res.data.primaryNationality) {
              this.primaryNationality = res.data.primaryNationality
              localStorage.setItem('primaryNationality', encrypt(JSON.stringify(res.data.primaryNationality)))
            } else {
              res.data.nationalityDtos.sort(function (a, b) {
                return a.creationTime - b.creationTime;
              });
              localStorage.setItem('primaryNationality', encrypt(JSON.stringify(res.data.nationalityDtos[0])))
            }
            for (let i = 0; i < this.dropdownList.maritalStatusList.length; i++) {
              this.dropdownList.maritalStatusList[i].id = 'a' + this.dropdownList.maritalStatusList[i].value
            }
            this.cdr.detectChanges();
            if (localStorage.getItem('edu') && this.personalDetailsData.dateOfBirth) {
              this.cdr.detectChanges();
              if (this.nationalityData.length !== 0 || this.primaryNationality != undefined) {
                this.goNext()
              } else {
                this.isImageAlert = true;
                this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
                this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.NATIONALITY_REQUIRED;
                return;
              }
            } else {
              await this.getUserPicture();
              await this.getAddressFormDetails();
            }
            localStorage.setItem('dob', encrypt(res.data.personalDetail.dateOfBirth))
            this.cdr.detectChanges();
            resolve(this.personalDetailsData);
          }
          (err) => {
          }
        }
      )
    })
      .catch(function (error) {
      })
  }
  //for admin
  public getUserPersonalDetailsAdmin(id) {
	  this.loaderService.setValue(true);
    return new Promise((resolve, reject) => {
      this.sharedService.getPersonalDetailsAdmin(id).subscribe(
        async (res: HecResponse) => {
			this.loaderService.setValue(false);
          for (let i = 0; i < this.dropdownList.maritalStatusList.length; i++) {
            this.dropdownList.maritalStatusList[i].id = 'a' + this.dropdownList.maritalStatusList[i].value
          }
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.personalDetailsData = res.data.personalDetails.personalDetail;
            this.nationalityData = res.data.personalDetails.nationalityDtos;
            this.isLocked = res.data.personalDetails.islocked
            localStorage.setItem('loginDetails',encrypt(JSON.stringify(res.data.personalDetails.loginDetail)))
            if (res.data.primaryNationality) {
              this.primaryNationality = res.data.personalDetails.primaryNationality
              localStorage.setItem('primaryNationality', encrypt(JSON.stringify(res.data.personalDetails.primaryNationality)))
            } else {
              res.data.personalDetails.nationalityDtos.sort(function (a, b) {
                return a.creationTime - b.creationTime;
              });
              localStorage.setItem('primaryNationality', encrypt(JSON.stringify(res.data.personalDetails.nationalityDtos[0])))
            }
            for (let i = 0; i < this.dropdownList.maritalStatusList.length; i++) {
              this.dropdownList.maritalStatusList[i].id = 'a' + this.dropdownList.maritalStatusList[i].value
            }
            this.cdr.detectChanges();
            if (localStorage.getItem('edu') && this.personalDetailsData.dateOfBirth) {
              this.cdr.detectChanges();
              if (this.nationalityData.length !== 0 || this.primaryNationality != undefined) {
                this.goNext()
              } else {
                this.isImageAlert = true;
                this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
                this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.NATIONALITY_REQUIRED;
                return;
              }
            } else {
				this.profileAvatarImg = res.data.picture;
				this.isImgAvailable = true;
			 this.addressDetailsData = res.data.address;
			 if (res.data.address.length > 0) {
				res.data.address.sort(function (obj1, obj2) {
				  return obj1.addressTypeCode - obj2.addressTypeCode;
				});
				localStorage.setItem('addresses', encrypt(JSON.stringify(res.data)))
				for (let j = 0; j < this.addressDetailsData.length; j++) {
				  for (let i = 0; i < res.data.address.length; i++) {
					if (this.addressDetailsData[j].addressTypeCode == res.data.address[i].addressTypeCode) {
					  this.addressDetailsData[j] = res.data.address[i];
					  this.getCitiesByCountry(this.addressDetailsData[j].countryId, j)
					  this.getPostalCodesByCity(this.addressDetailsData[j].cityId, j)
					  this.cdr.detectChanges();
					}
				  }
				  this.checkMatchingAddress();
				}
				resolve(this.addressDetailsData);
			  }
            }
            localStorage.setItem('dob', encrypt(res.data.personalDetails.personalDetail.dateOfBirth))
            this.cdr.detectChanges();
            resolve(this.personalDetailsData);
          }
          (err) => {
            this.loaderService.setValue(false);
          }
        }
      )
    })
      .catch(function (error) {
        this.loaderService.setValue(false);
      })
  }
  public getAddressFormDetails() {
    return new Promise((resolve, reject) => {
      this.profileService.getAddressDetails().subscribe(
        (res: HecResponse) => {
          this.cdr.detectChanges();
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            if (res.data.length > 0) {
              res.data.sort(function (obj1, obj2) {
                return obj1.addressTypeCode - obj2.addressTypeCode;
              });
              localStorage.setItem('addresses', encrypt(JSON.stringify(res.data)))
              for (let j = 0; j < this.addressDetailsData.length; j++) {
                for (let i = 0; i < res.data.length; i++) {
                  if (this.addressDetailsData[j].addressTypeCode == res.data[i].addressTypeCode) {
                    this.addressDetailsData[j] = res.data[i];
                    this.getCitiesByCountry(this.addressDetailsData[j].countryId, j)
                    this.getPostalCodesByCity(this.addressDetailsData[j].cityId, j)
                    this.cdr.detectChanges();
                  }
                }
                this.checkMatchingAddress();
              }
              resolve(this.addressDetailsData);
            } else {
            }
          } else {
          }
        },
        (err) => {
          this.loader = false;
          this.loaderService.setValue(this.loader);
          this.cdr.detectChanges();
        }
      )
    })
      .catch(function (error) {
      })
  }
  public getDistrictByCity(cityId, index, type?) {
    if (cityId != undefined) {
      this.sharedService.getDistrictsByCityId(cityId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.districtList[index] = res.data;
            if (this.matchedAddress && type) {
              this.matchedAddress = false;
            }
            this.cdr.detectChanges();
          }
          else {
          }
        },
        (err) => {
        }
      )
    }
  }
  public getPostalCodesByCity(cityId, index, type?) {
    this.getDistrictByCity(cityId, index, type);
    if (cityId != undefined) {
      this.sharedService.getPostalCodeByCityId(cityId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.postalList[index] = res.data;
            this.cdr.detectChanges();
          }
          else {
          }
        },
        (err) => {
        }
      )
    }
  }
  public getCitiesByCountry(countryId, index, type?) {
    this.selectedCountryId[index] = countryId;
    if (countryId != undefined) {
      this.sharedService.getCitiesByCountryId(countryId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.cityList[index] = res.data;
            this.cdr.detectChanges();
            if (this.matchedAddress && type) {
              this.matchedAddress = false;
            }
            this.cdr.detectChanges();
          } else {
          }
        },
        (err) => {
        }
      )
    }
  }
  public submitProfile() {
    if (this.personalDetailsForm.dirty && this.personalDetailsForm.valid && this.isImgAvailable) {
      this.markFormsTouched(this.personalDetailsForm)
      if (this.validate(this.personalDetailsForm) && this.isImgAvailable) {
        this.loaderService.setValue(true)
        let payload = this.constructPayload();
        for (let i = 0; i < this.dropdownList.titleList['length']; i++) {
          if (this.dropdownList.titleList[i].value == payload.profileDto.titleId) {
            payload.profileDto.title = this.dropdownList.titleList[i].label;
          }
        }
        if (this.personalDetailsForm.form.controls.firstName.dirty || this.personalDetailsForm.form.controls.lastName.dirty ||
          this.personalDetailsForm.form.controls.middleName.dirty) {
          let data = decrypt(localStorage.getItem('esp-profile-details'));
          data = JSON.parse(data);
          if (this.personalDetailsForm.value.middleName) {
            data.fullName = this.personalDetailsForm.value.firstName + ' ' + this.personalDetailsForm.value.middleName + ' ' + this.personalDetailsForm.value.lastName;
          } else {
            data.fullName = this.personalDetailsForm.value.firstName + ' ' + this.personalDetailsForm.value.lastName;
          }
          localStorage.removeItem('esp-profile-details');
          data = encrypt(JSON.stringify(data));
          localStorage.setItem('esp-profile-details', data);
          localStorage.setItem('updateInfo', encrypt('1'));
        }
        localStorage.setItem('dob', encrypt(payload.profileDto.dateOfBirth))
        let profilePayload = {
          data: {
            personalDetail: payload.profileDto
          }
        }
        profilePayload.data.personalDetail.dateOfBirth = new Date(profilePayload.data.personalDetail.dateOfBirth).getFullYear() + '-' + (new Date(profilePayload.data.personalDetail.dateOfBirth).getMonth() + 1) + '-' + new Date(profilePayload.data.personalDetail.dateOfBirth).getDate()
        this.profileService.postSaveUserProfile(profilePayload).subscribe(
          (res: HecResponse) => {
        this.loaderService.setValue(false)
            if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
              this.profileService.saveAddress(payload.addressDto).subscribe(
                async (res: HecResponse) => {
                  if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
                    // this.parentComp.profileUpdated = true;
                    await this.getUserPersonalDetails();
                    await this.getAddressFormDetails();
                    if (this.nationalityData.length !== 0 || this.primaryNationality != undefined) {
                      this.goNext()
                    } else {
                      this.isAlertVisible = true;
                      this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
                      this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.NATIONALITY_REQUIRED;
                      return;
                    }
                  } else {
                    await this.getAddressFormDetails();
                    this.loader = false;
                    this.loaderService.setValue(this.loader);
                    this.isAlertVisible = true;
                    this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
                    this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.ERROR_SAVING_ADDRESS;
                    setTimeout(() => {
                      this.isAlertVisible = false;
                    }, 4000)
                  }
                },
                (err) => {
                  this.loader = false;
                  this.loaderService.setValue(this.loader);
                  this.isAlertVisible = true;
                  this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
                  this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.ERROR_SAVING_ADDRESS;
                  setTimeout(() => {
                    this.isAlertVisible = false;
                  }, 4000)
                }
              )
            } else {
              this.loader = false;
              this.loaderService.setValue(this.loader);
              this.isAlertVisible = true;
              this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
              this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.ERROR_PROFILE;
              setTimeout(() => {
                this.isAlertVisible = false;
              }, 4000)
            }
          },
          (err) => {
            this.loader = false;
            this.loaderService.setValue(this.loader);
            this.isAlertVisible = true;
            this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
            this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.ERROR_SAVING_ADDRESS;
            setTimeout(() => {
              this.isAlertVisible = false;
            }, 4000)
          }
        )
      } else if (!this.validate(this.personalDetailsForm) && this.isImgAvailable) {
        return;
      }
      else {
        this.isImageAlert = true;
        window.scrollTo(0, 50)
        this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
        this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.PROFILE_PICTURE_ERROR;
        return;
      }
    } else if (this.personalDetailsForm.valid && !this.isImgAvailable) {
      this.isImageAlert = true;
      window.scrollTo(0, 50)
      this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
      this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.PROFILE_PICTURE_ERROR;
      return;
    }
    else if (this.personalDetailsForm.valid && this.isImgAvailable) {
      if (this.nationalityData.length !== 0 || this.primaryNationality != undefined) {
        this.goNext()
      } else {
        this.isAlertVisible = true;
        this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
        this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.NATIONALITY_REQUIRED;
        return;
      }
    } else {
      this.markFormsTouched(this.personalDetailsForm)
      return
    }
  }
  public markFormsTouched(form): void {
    CommonHelper.markFormGroupTouched(form);
  }
  public validate(f): boolean {
    if (f.status === 'VALID') {
      return true;
    }
  }
  public getDropdownValues(value, type) {
    if (type == 'gender') {
      this.dropdownValues.genderValue = (this.dropdownList.genderList as any).find((v: any) => v.value == value).label;
      return this.dropdownValues.genderValue;
    } else if (type == 'marital') {
      this.dropdownValues.maritalValue = (this.dropdownList.maritalStatusList as any).find((v: any) => v.value == value).label;
      return this.dropdownValues.maritalValue;
    }
    else if (type == 'country') {
      this.dropdownValues.countryValue = (this.dropdownList.countryList as any).find((v: any) => v.value == value).label;
      return this.dropdownValues.countryValue;
    }
    else if (type == 'religion') {
      this.dropdownValues.religionValue = (this.dropdownList.religionList as any).find((v: any) => v.value == value).label;
      return this.dropdownValues.religionValue;
    }
    else if (type == 'identity') {
      this.dropdownValues.identityValue = (this.dropdownList.identityTypeList as any).find((v: any) => v.value == value).label;
      return this.dropdownValues.identityValue;
    }
    else if (type == 'fatherJob') {
      this.dropdownValues.occupationList = (this.dropdownList.occupationList as any).find((v: any) => v.value == value).label;
      return this.dropdownValues.occupationList;
    }
    this.cdr.detectChanges();
  }
  private constructPayload(): ProfileModel {
    CommonHelper.valuesFromFormToModel(this.profileDetails, this.personalDetailsForm.value);
    let payload = this.profileDetails;
    payload.addressDto = [];
    payload.profileDto = this.personalDetailsForm.value;
    if (this.isLocked) {
      payload.profileDto.firstName = this.personalDetailsData.firstName
      payload.profileDto.lastName = this.personalDetailsData.lastName
      payload.profileDto.dateOfBirth = this.personalDetailsData.dateOfBirth
      payload.profileDto.genderCode = this.personalDetailsData.genderCode
    }
    for (let i = 0; i < this.addressDetailsData.length; i++) {
      payload.addressDto.push({
        addressTypeCode: this.personalDetailsForm.value['addressTypeCode' + i],
        address: this.personalDetailsForm.value['address' + i],
        countryId: this.personalDetailsForm.value['countryId' + i],
        domicileId: this.personalDetailsForm.value['domicileId' + i],
        postalCodeId: this.personalDetailsForm.value['postalCodeId' + i],
        cityId: this.personalDetailsForm.value['cityId' + i],
        id: this.personalDetailsForm.value['id' + i]
      })
      delete payload.profileDto['address' + i];
      delete payload.profileDto['cityId' + i];
      delete payload.profileDto['countryId' + i];
      delete payload.profileDto['domicileId' + i];
      delete payload.profileDto['postalCodeId' + i];
      delete payload.profileDto['id' + i];
      delete payload.profileDto['addressTypeCode' + i];
      delete payload.profileDto['searchCtrl']
    }
    return payload;
  }
  public async changeFileSelection(e: FileList) {
    let image = e[0];
    let test: File;
    const file = e[0];
    if (this.isValidFile(file)) {
      this.loader = true;
      this.loaderService.setValue(this.loader);
      this.cdr.detectChanges();
      // this.ng2ImgMax.compressImage(image, 0.575).subscribe(
      //   async result => {
      //     test = result;
      //     await this.setAttachmentsPayload(result);
      //     this.uploadAttachment();
      //   },
      //   error => {
      //     this.loader = false;
      //     this.loaderService.setValue(this.loader);
      //   }
      // );
      debugger
      const reader = new FileReader();
      reader.onload = async () => {
        const imageBase64 = reader.result as string;

        // Compress image (needs full base64 URI)
        this.imageCompress.compressFile(imageBase64, -1, 50, 50)
          .then(async (compressedImage: string) => {
            // ✅ Remove the prefix after compression
            const strippedBase64 = compressedImage.replace(/^data:image\/[a-z]+;base64,/, '');

            await this.setAttachmentsPayload(strippedBase64); // now clean
            this.uploadAttachment();
          })
          .catch((error) => {
            this.loader = false;
            this.loaderService.setValue(this.loader);
          });
      };
      reader.readAsDataURL(file);


    }
  }
  private isValidFile(file) {
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name;
    const fileSizeinKB = file.size / 1024;
    if (extensions.indexOf(ext) === -1) {
      this.isImageAlert = true;
      this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning;
      this.alertMsgValue = 'Error in uploading ' + file.name + ' due to invalid file type.';
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    } else if (!file.name.match(HEC_CONSTANTS.CONSTANT_VALUES.fileAllowedFormat)) {
      this.isImageAlert = true;
      this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning;
      this.alertMsgValue = 'Invalid File Name.';
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    else if (fileSizeinKB > this.maxSize) {
      this.isImageAlert = true
      this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning;
      this.alertMsgValue = file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.';
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    return true;
  }
  // private async setAttachmentsPayload(file) {
  //   this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
  // }
  private async setAttachmentsPayload(base64: string) {
		this.attachmentBase64 = base64;
	}

  private uploadAttachment() {
    this.selectedFilePayload = '';
    this.selectedFilePayload = this.attachmentBase64;
    let payload = {
      data: this.selectedFilePayload
    }
    debugger
    this.sharedService.postUpdateProfilePicture(payload)
      .subscribe(
        (res: HecResponse) => {
          // debugger
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.isImageAlert = false;
            this.getUserPicture('local');
            this.cdr.detectChanges();
          }
          else {
            // this.ale
          }
        },
        (err) => {
          this.loader = false;
          this.loaderService.setValue(this.loader);
          this.isImageAlert = true;
          this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning;
          this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.UPLOAD_PICTURE_ERROR;
        }
      )
  }
  private convertFileToBase64(file): any {
    return new Promise((resolve, reject) => {
      CommonHelper.convertFileToBase64(file).then((result) => {
        resolve(result);
      })
        .catch(function (error) {
          resolve(null);
        })
    })
  }
  public goBack() {
	  if(this.pucaDataService.isAdmin){
		this.router.navigate(['/admin-dashboard/PAK-US-Admnin-Dashboard'])
	  }
	  else{
		this.router.navigate(['/'])
	  }
  }
  private checkMatchingAddress() {
    for (let i = 0; i < this.addressDetailsData.length - 1; i++) {
      if (this.addressDetailsData[0].address == this.addressDetailsData[i + 1].address &&
        this.addressDetailsData[0].cityId == this.addressDetailsData[i + 1].cityId &&
        this.addressDetailsData[0].countryId == this.addressDetailsData[i + 1].countryId &&
        this.addressDetailsData[0].provinceId == this.addressDetailsData[i + 1].provinceId &&
        this.addressDetailsData[0].domicileName == this.addressDetailsData[i + 1].domicileName &&
        this.addressDetailsData[0].postalCodeId == this.addressDetailsData[i + 1].postalCodeId
      ) {
        this.matchedAddress = true
      } else {
        this.matchedAddress = false
      }
    }
  }
  public async getPermAddressForMailing(addressData, id, addressTypeCode) {
    // this.profileComp.loader = true;
    // this.loaderService.setValue(true)
    this.addressDetailsData[1].addressTypeCode = addressTypeCode;
    this.addressDetailsData[1].id = id;
    this.addressDetailsData[1].address = this.personalDetailsForm.value['address0']
    this.addressDetailsData[1].countryId = this.personalDetailsForm.value['countryId0']
    await this.getCitiesByCountry(this.personalDetailsForm.value['countryId0'], 1)
    this.addressDetailsData[1].cityId = this.personalDetailsForm.value['cityId0']
    this.getPostalCodesByCity(this.personalDetailsForm.value['cityId0'], 1)
    this.addressDetailsData[1].domicileId = this.personalDetailsForm.value['domicileId0']
    this.addressDetailsData[1].postalCodeId = this.personalDetailsForm.value['postalCodeId0']
    this.matchedAddress = true;
    this.personalDetailsForm.form.markAsDirty()
    this.checkMatchingAddress()
    this.cdr.markForCheck()
    // this.saveAddressData(payload);
  }
  public addressChange(value) {
    if (this.matchedAddress || this.matchedAddress == undefined) {
      this.matchedAddress = false;
      this.cdr.detectChanges();
    }
  }


	private async checkEligibility() {
		try {
			let data = decrypt(localStorage.getItem('esp-profile-details'));
			data = JSON.parse(data);
			const res: any = await this.pucaService.checkEligibility(data['profileId']).toPromise();
			if (res.code == 0) {
				let eligibility: EligibilityModel = new EligibilityModel();
				eligibility = res.result;

				if (eligibility.isNational) {
					this.nextComponent.emit(true);
					if (!this.cdr["destroyed"]) this.cdr.detectChanges();
				} else {
					this.isAlertVisible = true;
					this.alertType = 'error';
					this.alertMsgValue = `Only Pakistani/AJK nationals can apply for scholarship .`;
				}
			} else {
				this.isAlertVisible = true;
				this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
				this.alertMsgValue = res.message || 'Unable to verify eligibility. Please try again.';
				this.cdr.detectChanges();
			}
		} catch (error) {
			this.isAlertVisible = true;
			this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
			this.alertMsgValue = 'Unable to verify eligibility. Please try again.';
			this.cdr.detectChanges();
		}
	}
}
